'use strict';


module.exports = require('./lib/');



//////////////////
// WEBPACK FOOTER
// ../~/markdown-it/index.js
// module id = 320
// module chunks = 0